import 'src/global.css';

// ----------------------------------------------------------------------

import { useEffect } from 'react';
import { notification } from 'antd';
import { CacheProvider } from '@emotion/react';

import { Router } from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import { LocalizationProvider } from 'src/locales';
import { I18nProvider } from 'src/locales/i18n-provider';
import { ThemeProvider } from 'src/theme/theme-provider';

import { Snackbar } from 'src/components/snackbar';
import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

import { AuthProvider } from 'src/auth/context/jwt';
import { WebSocketProvider } from 'src/contexts/webSocketContext';
import { AuthSocketWrapper } from 'src/auth/components/AuthSocketWrapper';

import createEmotionCache from './createEmotionCache';

notification.config({
  duration: 3,
  rtl: true,
  maxCount: 1,
});

const clientSideEmotionCache = createEmotionCache();

export default function App() {
  const [api, contextHolder] = notification.useNotification();
  useScrollToTop();

  useEffect(() => {
    const channel = new BroadcastChannel('notifications');
    channel.addEventListener('message', (event) => {});
  }, []);

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').catch(console.error);
  }
  return (
    <I18nProvider>
      {contextHolder}
      <CacheProvider value={clientSideEmotionCache}>
        <LocalizationProvider>
          <AuthProvider>
            <WebSocketProvider>
              <AuthSocketWrapper>
                <SettingsProvider settings={defaultSettings}>
                  <ThemeProvider>
                    <MotionLazy>
                      <Snackbar />
                      <ProgressBar />
                      <SettingsDrawer />
                      <Router />
                    </MotionLazy>
                  </ThemeProvider>
                </SettingsProvider>
              </AuthSocketWrapper>
            </WebSocketProvider>
          </AuthProvider>
        </LocalizationProvider>
      </CacheProvider>
    </I18nProvider>
  );
}
